<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-correo">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-4">
                  <p :key="ind" v-for="(d,ind) in datos1">
                    <b>{{ d.codigo }}: </b> {{ d.nombre }}
                  </p>
                </div>

                <div class="col-sm-4">
                  <p :key="ind" v-for="(d,ind) in datos2">
                    <b>{{ d.codigo }}: </b> {{ d.nombre }}
                  </p>
                </div>

                <div class="col-sm-4">
                  <p :key="ind" v-for="(d,ind) in datos3">
                    <b>{{ d.codigo }}: </b> {{ d.nombre }}
                  </p>
                </div>
              </div>
              <p class="text-center text-danger"> {{msg}} </p>
            </div>
            
            <Alertas ref="alertar"  />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Enviar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
                msg: null,
                datos1:[],
                datos2:[],
                datos3:[],
            }
        },
        watch:{
  
            'obj.xsql': function(){
              this.datos = [];
              if( this.obj.xsql == null ) return;
              this.cargar();
            },
            
        },
        components:{Alertas},
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            submit(){},
            cargar(){
                window.console.log( "ZZZZ ",this.obj.xsql,typeof(this.obj.xsql) );
                var vue = this;
                vue.$refs.alertar.cargando();
                vue.activo = false;

                this.$apollo.query({
                    query: vue.obj.xsql,
                }).then((data) => {
                    var datas1 = [];
                    var datas2 = [];
                    var datas3 = [];
                    for (var propName in data.data) { 
                      if( propName == "getCiudades" || propName == "getDepartamentos" || propName == "getProfesiones" ){
                        var tam = data.data[propName].length/3;
                        window.console.log( propName )
                        var str = '--------\n';
                        data.data[propName].forEach( function(e){ 
                          if( propName == "getCiudades" ) {
                            if( !e.departamento ) e.departamento = {nombre:''};
                            e.nombre = e.nombre+' ('+e.departamento.nombre+')';
                          }
                          str += e.id+'\n';
                          if( datas1.length < tam ) datas1.push( {nombre:e.nombre,codigo:e.id} );
                          else if( datas2.length < tam ) datas2.push( {nombre:e.nombre,codigo:e.id} );
                          else datas3.push( {nombre:e.nombre,codigo:e.id} );
                        });
                        window.console.log( str )
                      }
                    }
                    this.datos1 = datas1;
                    this.datos2 = datas2;
                    this.datos3 = datas3;
                    window.console.log( datas1,datas2 );
                    vue.$refs.alertar.reset();

                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            },
        },
    
    }
</script>